import React, { useEffect, useState } from 'react';
import '../../beneficiary.css';
import { Modal } from "react-bootstrap";
import Button from '@components/common/Button';
import Successsvg from '@assets/svg_main/otp_success_svg.svg';



interface showModalProps {
    showModal: boolean;
    handleClose: (type:string) => void;
};

const CustomiseAbhaAddressProceedModal = ({ showModal, handleClose}: showModalProps) => {
    useEffect(() => {
        if (showModal) {
            const timer = setTimeout(() => {
                handleClose('close');
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showModal, handleClose]);

    return (
        <>
            <div className="modal_gender_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={()=>handleClose('close')}
                    dialogClassName={'custom-abha-address-modal'}
                    centered={true}
                >

                    <Modal.Body  >
                        <div className='custom-abha-address-proceed-modal-container'>
                            <Successsvg className="otp_success_card_image" />
                            <h4 className='demographic_headings custom-abha-address-proceed-modal-heading'>ABHA address has been created successfully</h4>
                            <Button
                                onClick={()=>handleClose('proceed')}
                                buttonName='Close'
                                colorType='primary'
                                id="customize-btn-on-proceed-modal"
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default CustomiseAbhaAddressProceedModal;